import { writable } from 'svelte/store';

export const showNotifications = writable(false);
